import { localState, sessionState } from 'src/app/core/services/signal-state.storage';
import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AppService } from 'src/app/app.service';
import { transformIntoApiCallObj } from 'src/app/gdo/gdo-shared/Models/Constants';
import { PaymentMethodInfo } from 'src/app/gdo/gdo-shared/Models/Interfaces';
import { filterAccountPaymentMethodsForDisplay } from 'src/app/shared/Models/payment-method-filter';
import { StatusDTO } from 'src/app/gdo/gdo-shared/Models/Models';
import { GdoStepCompletionStatusComponent } from 'src/app/gdo/gdo-shared/gdo-shared-components/gdo-step-completion-status/gdo-step-completion-status.component';

@Component({
    selector: 'app-gdo-subscription-payment-method',
    templateUrl: './gdo-subscription-payment-method.component.html',
    styleUrls: ['./gdo-subscription-payment-method.component.scss'],
    standalone: false
})
export class GdoSubscriptionPaymentMethodComponent implements OnInit {
  @Input() type!: string;
  @Input() subsForm!: UntypedFormGroup;
  localItem: string | null = null;
  paymentOptions: PaymentMethodInfo[] = [];
  initialForm: UntypedFormGroup = new UntypedFormGroup({
    availablePaymentMethodSelection: new UntypedFormControl(''),
  });

  defaultPaymentMethodNo = -1;
  lastPaymentMethodNo = -1;
  allowAddPaymentMethod: boolean = true;
  isWebView: boolean = false;
  migrationInProgress: boolean = true;

  constructor(
    private appService: AppService,
    private dialog: MatDialog,
    private router: Router
  ) {
    // this.localItem = localState.getItem('paymentOptions');
    // if (this.localItem == null) {
    //   this.paymentOptions = [];
    // } else {
    //   this.paymentOptions = JSON.parse(this.localItem);
    // }
    // 
  }

  async ngOnInit(): Promise<void> {
    await this.loadMigrationFlag();
    this.getPaymentMethods();
    this.getDefaultPaymentMethodsNo();
    this.isWebView = this.appService.getWebviewCurrentStatus();
  }

  private async loadMigrationFlag(): Promise<void> {
    try {
      const cfg = await this.appService.getPaymentConfig().toPromise();
      this.migrationInProgress =
        cfg?.migrationInProgress !== undefined ? cfg.migrationInProgress : true;
    } catch {
      this.migrationInProgress = true;
    }
  }
  deleteCard(paymentCard: PaymentMethodInfo) {
    this.deletePaymentMethod(paymentCard);
  }
  addNewPaymentMethod() {
    const contactDetails = this.subsForm.get('contactDetails');
    const packageSelection = this.subsForm
      .get('packageDetails')
      ?.get('availablePackageSelection');
    if (!contactDetails || !packageSelection) return;
    let subsContactData = contactDetails.value;
    let subsSelectedPackage = packageSelection.value;
    this.appService.setSubsContactInfo(subsContactData);
    this.appService.setSubsSelectedPackage(subsSelectedPackage);
    if (this.type) {
      this.router.navigate(['/gdoWV/addNewPaymentOption'], {
        state: { paymentOptionsLength: this.paymentOptions.length },
      });
    } else {
      this.appService.setAddingPaymentMehodFromSubscription(true);
      this.router.navigate(['/billing/addNewPaymentOption'], {
        state: { paymentOptionsLength: this.paymentOptions.length },
      });
    }
  }

  deletePaymentMethod(paymentCard: PaymentMethodInfo) {
    if (paymentCard.payment_method_no) {
      let hidasId = sessionState.getItem('userId')
      let data = {
        payment_method_no: paymentCard.payment_method_no,
      };
      data = transformIntoApiCallObj(data, 'remove_acct_payment_method_m');
      // NOTE: TODO replace following aria pass connect api with wrapper once wrapper returns all information
      this.appService.AriaPassThroughConnect(data).subscribe(async (res) => {
        if (res && res.error_code === 0) {
          // Gap 2: detach from Stripe if this is a Stripe card (no-op for Braintree tokens)
          this.appService.detachStripeCardIfNeeded(paymentCard.bill_agreement_id).subscribe();
          this.getPaymentMethods();
          this.getDefaultPaymentMethodsNo();
        }
      });
    }
  }

  defaultCard(paymentCard: PaymentMethodInfo) {
    let data: any = {
      billing_group_no: this.appService.getSelectedMp().billingGroupNo,
      primary_payment_method_no: paymentCard?.payment_method_no,
    };

    data = transformIntoApiCallObj(data, 'update_acct_billing_group_m');

    this.appService.AriaPassThroughConnect(data).subscribe((response) => {
      if (response && response.error_code == 0 && response.error_msg === 'OK') {
        this.defaultPaymentMethodNo =
          response?.billing_contact_info[0]?.payment_method_no;

        this.appService.setDefaultPaymentNo(this.defaultPaymentMethodNo);
        // this.getDefaultPaymentMethodsNo();

        let statusData: StatusDTO = {
          title: '',
          details: 'Default card updated successfully',
          stepSuccessful: true,
        };

        let ref;

        if (this.isWebView) {
          ref = this.dialog.open(GdoStepCompletionStatusComponent, {
            // width: '35vw',
            // height: '31vw',
            data: statusData,
            panelClass: 'custom-modalbox-webview',
          });
        } else {
          ref = this.dialog.open(GdoStepCompletionStatusComponent, {
            // width: '35vw',
            // height: '31vw',
            data: statusData,
            panelClass: 'custom-modalbox-desktop',
          });
        }

        ref.afterClosed().subscribe((result) => {
          this.getDefaultPaymentMethodsNo();
        });
      } else {
        let statusData: StatusDTO = {
          title: 'Error occured',
          details: response.error_msg,
          stepSuccessful: false,
        };
      }
    });
  }

  getPaymentMethods() {
    let data = {
      filter_status: 1,
      payments_returned: 3,
    };
    data = transformIntoApiCallObj(
      data,
      'get_acct_payment_methods_and_terms_m'
    );
    // NOTE: TODO replace following aria pass connect api with wrapper once wrapper returns all information
    this.appService.AriaPassThroughConnect(data).subscribe(async (res) => {
      if (res && res.error_code === 0) {
        if (res?.account_payment_methods) {
          this.paymentOptions = filterAccountPaymentMethodsForDisplay(
            res.account_payment_methods,
            this.migrationInProgress
          );
          if (this.paymentOptions.length >= 9) {
            this.allowAddPaymentMethod = false;
          } else {
            this.allowAddPaymentMethod = true;
          }
        }
        for (const iterator of this.paymentOptions) {
          // this.lastPaymentMethodNo = iterator.payment_method_no
          if (
            iterator.payment_method_no &&
            iterator.payment_method_no > this.lastPaymentMethodNo
          ) {
            this.lastPaymentMethodNo = iterator.payment_method_no;
          }
        }
        if (this.lastPaymentMethodNo < 0) {
          this.lastPaymentMethodNo == 1;
        }
        this.appService.setLastPaymentNo(this.lastPaymentMethodNo);
      }
    });
  }

  getDefaultPaymentMethodsNo() {
    let data = {
      include_billing_groups: 1,
    };
    data = transformIntoApiCallObj(data, 'get_acct_details_all_m');
    // NOTE: TODO replace following aria pass connect api with wrapper once wrapper returns all information
    this.appService.AriaPassThroughConnect(data).subscribe((res) => {
      if (res && res.error_code === 0) {
        if (res.billing_groups_info && res.billing_groups_info.length > 0) {
          this.defaultPaymentMethodNo =
            res?.billing_groups_info[0].primary_payment_method_id;
          if (this.paymentOptions.length === 1) {
            this.defaultPaymentMethodNo =
              this.paymentOptions[0].payment_method_no;
          }

          if (this.paymentOptions.length > 0) {
            let index = this.paymentOptions.findIndex((card) => {
              return card.payment_method_no === this.defaultPaymentMethodNo;
            });

            const defaultCard = this.paymentOptions.find((card) => {
              return card.payment_method_no === this.defaultPaymentMethodNo;
            });

            let cardOptions = this.paymentOptions.filter((card) => {
              return card.payment_method_no !== this.defaultPaymentMethodNo;
            });

            if (defaultCard) {
              this.paymentOptions.splice(0, this.paymentOptions.length);
              this.paymentOptions = [defaultCard, ...cardOptions];
              this.controlChange(index);
            }
          }
          this.appService.setDefaultPaymentNo(this.defaultPaymentMethodNo);
        }
        //To allow for next button to be activated
        for (const iterator of this.paymentOptions) {
          if (
            iterator.payment_method_no &&
            iterator.payment_method_no == this.defaultPaymentMethodNo
          ) {
            this.subsForm
              .get('paymentDetails')
              ?.get('availablePaymentMethodSelection')
              ?.setValue(iterator);
            break;
          }
        }
      }
    });
  }

  onCancel() {
    sessionState.setItem('planType', 'notearlybird');
    if (this.type) {
      this.router.navigate(['/gdoWV'], { replaceUrl: true });
    } else {
      this.router.navigate(['/gdo-product'], { replaceUrl: true });
    }
  }

  trackByPaymentMethod(index: number, paymentCard: PaymentMethodInfo): number {
    return paymentCard?.payment_method_no ?? index;
  }

  controlChange(i: any) {
    const cards = document.querySelectorAll('.border-card');
    const selectedCard = cards[i];

    if (!selectedCard) {
      return;
    }

    cards.forEach((card) => {
      card.classList.add('cir-border'); //add default grey border
      card.classList.remove(
        this.isWebView ? 'card-selected-webview' : 'card-selected'
      ); // remove selected default
    });

    // now remove default border and set selected border class
    selectedCard.classList.remove('cir-border');
    selectedCard.classList.add(
      this.isWebView ? 'card-selected-webview' : 'card-selected'
    );
  }

  trackByNgForItem(index: number, item: any): string | number {
    return item?.value ?? item?.payment_method_no ?? item?.paymentMethodNo ?? item?.couponCode ?? item?.id ?? item?.title ?? item?.displayValue ?? item ?? index;
  }
}
